import * as React from 'react';
/**
 *
 * Original name: cloud done
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1073
 *
 */
export const CloudDoneLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M16.245 10.005C16.15 7.49 14.579 6 12 6s-4.15 1.492-4.245 4.005C5.242 10.1 3.75 11.67 3.75 14.25c0 2.578 1.492 4.142 4 4.24v-1.507c-1.652-.085-2.5-.997-2.5-2.733 0-1.825.926-2.75 2.75-2.75h1.25v-1.25c0-1.825.925-2.75 2.75-2.75s2.75.925 2.75 2.75v1.25H16c1.825 0 2.75.925 2.75 2.75 0 1.736-.848 2.648-2.5 2.733v1.508c2.509-.1 4-1.665 4-4.241 0-2.575-1.491-4.15-4.005-4.245Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m11.75 16.167-1.72-1.72-1.06 1.061 2.78 2.78 4.28-4.28-1.06-1.06-3.22 3.22Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
